import s from "../ImageWrapper.module.scss";

const SingleImage = ({ image }) => (
  <div className={s.imageContainer}>{image && <div>{image}</div>}</div>
);

export default SingleImage;
